import { Component, EventEmitter, Output } from '@angular/core'

@Component({
  selector: 'app-import-type-selector',
  templateUrl: './import-type-selector.component.html',
  styleUrls: ['./import-type-selector.component.scss']
})
export class ImportTypeSelectorComponent {
  @Output() typeSelected = new EventEmitter<string>()
  @Output() cancel = new EventEmitter<void>()
  @Output() filterFileSelected = new EventEmitter<Event>()

  importTypes = [
    {
      id: 'products',
      icon: 'assets/icons/cube.svg',
      title: 'Products',
      desc: 'Import or update products from external sources.',
      buttonLabel: 'Import Products'
    },
    {
      id: 'categories',
      icon: 'assets/icons/categories_icon.svg',
      title: 'Categories',
      desc: 'Import product categories and organization hierarchy.',
      buttonLabel: 'Import Categories'
    },
    {
      id: 'orders',
      icon: 'assets/icons/cart_gray.svg',
      title: 'Orders',
      desc: 'Import historical orders for reporting and tracking.',
      buttonLabel: 'Import Orders'
    }
  ]
}
